import SidebarAndPanesWithRouting from '@/components/layouts/SidebarAndPanesWithRouting.vue';
import Summary from './children/Summary/Summary.vue';
import Features from './children/Features.vue';
import Messages from './children/Messages.vue';

const rootRoute = {
  path: 'platform',
  name: 'Platform',
  component: SidebarAndPanesWithRouting,
  meta: {
    auth: true,
  },
  props: {
    baseResource: '/metrics/platform',
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: 'summary',
    name: 'Metrics.Platform.Summary',
    component: Summary,
    meta: {
      label: 'Summary',
      ...commonChildMeta,
    },
  },
  {
    path: 'features',
    name: 'Metrics.Platform.Features',
    component: Features,
    meta: {
      label: 'Communication',
      ...commonChildMeta,
    },
  },
  {
    path: 'messages',
    name: 'Metrics.Platform.Messages',
    component: Messages,
    meta: {
      label: 'Messages',
      ...commonChildMeta,
    },
  },
];

rootRoute.props.children = childRoutes;

export default {
  ...rootRoute,
  children: childRoutes,
};
